import { axiosIamInstance } from './http-common'

export interface Application {
  code: string
  name: string
  url: string
  permissions: string[]
}

export interface Organization {
  organizationCode: string
  icon: string
  name: string
}

export interface OrganizationResponse {
  organizations: Organization[]
  page: number
  size: number
  total: number
}

export interface OrganizationDetails {
  name: string
  code: string
  address: string
  city: string
  contactEmail: string
  contactFirstName: string
  contactLastName: string
  contactPhone: string
  country: string
  legalName: string
  number: string
  phone: string
  postCode: string
  taxNumber: string
  privacy: {
    type: string
    allowedDomains: string[]
  }
}

class UserService {
  async listOrganizations(page = 0, size = 20): Promise<OrganizationResponse> {
    return (await axiosIamInstance.get('/my-organizations', { params: { page, size } }))?.data
  }

  async listApplications(organization: string): Promise<Application[]> {
    return (await axiosIamInstance.get(`/${organization}/applications/access`))?.data
  }
}

export default new UserService()
